// extracted by mini-css-extract-plugin
export default {"actions":"e761f8ca8ac9ce88","action":"_7954003711f7f23a"};